import * as XLSX from 'xlsx';

if (document.querySelector('[data-control="qualityStats"]')) {
    (function() {
        var AU_API = (window.AUApi && window.AUApi.qualityStatistics) || {};
        var STATISTICS_API = AU_API.statistics;
        var SEASONS_API = AU_API.seasons;
        var REGIONS_API = AU_API.regions || {};
        var REGION_NAMES = Object.keys(REGIONS_API);
        var inScopeSites = null;

        function buildUrl(template, tokens) {
            if (!template) return null;
            return Object.keys(tokens || {}).reduce(function(url, key) {
                return url.split('{' + key + '}').join(tokens[key]);
            }, template);
        }

        function extractArray(data) {
            if (Array.isArray(data)) return data;
            if (data && Array.isArray(data.value)) return data.value;
            return [];
        }

        function getSiteName(site) {
            return site.site || site.Site || site.description || site.Description || '';
        }

        var root = document.querySelector('[data-control="qualityStats"]');

        function q(selector) {
            return root.querySelector(selector);
        }

        function getGrainTabs() {
            return Array.prototype.slice.call(
                root.querySelectorAll('.quality-stats__grain-tab')
            );
        }

        function isTrue(value) {
            return value === 'true';
        }

        function readColumn(el) {
            return {
                field: el.getAttribute('data-field') || undefined,
                testType: el.getAttribute('data-test-type') || undefined,
                label: el.getAttribute('data-label') || '',
                cellClass: el.getAttribute('data-cell-class') || '',
                isQuality: isTrue(el.getAttribute('data-is-quality')),
            };
        }

        function readGrainTypes() {
            return getGrainTabs()
                .map(function(tab) {
                    return {
                        code: tab.getAttribute('data-grain') || '',
                        label:
                            tab.getAttribute('data-label') ||
                            tab.textContent.trim(),
                    };
                })
                .filter(function(grain) {
                    return grain.code;
                });
        }

        function readBaseColumns() {
            return Array.prototype.slice
                .call(
                    root.querySelectorAll('[data-control="baseColumns"] span')
                )
                .map(readColumn);
        }

        function readGrainColumns() {
            var columns = {};
            root.querySelectorAll('[data-control="grainColumns"]').forEach(
                function(group) {
                    var grain = group.getAttribute('data-grain');
                    if (!grain) return;
                    columns[grain] = Array.prototype.slice
                        .call(group.querySelectorAll('span'))
                        .map(readColumn);
                }
            );

            getGrainTabs().forEach(function(tab) {
                var grain = tab.getAttribute('data-grain');
                if (!grain) return;
                if (!columns[grain]) columns[grain] = [];
            });
            return columns;
        }

        var GRAIN_TYPES = readGrainTypes();
        var BASE_COLS = readBaseColumns();
        var GRAIN_COLUMNS = readGrainColumns();

        var defaultGrain = GRAIN_TYPES[0] || { code: '', label: '' };

        function getColumns(grainCode) {
            return BASE_COLS.concat(
                GRAIN_COLUMNS[grainCode] ||
                    GRAIN_COLUMNS[defaultGrain.code] ||
                    []
            );
        }

        var currentSeason = '';
        var currentGrain = defaultGrain.code;
        var currentData = [];
        var currentLabel = '';
        var currentGrainLabel = defaultGrain.label;
        var dataCache = {};

        var receivalsDate = q('[data-control="receivalsDate"]');
        var seasonDropdown = q('[data-control="seasonDropdown"]');
        var seasonToggle = q('[data-control="seasonToggle"]');
        var seasonValue = q('[data-control="seasonValue"]');
        var seasonMenu = q('[data-control="seasonMenu"]');
        var seasonItemPrototype = q('[data-control="seasonItemPrototype"]');
        var seasonItems = [];
        var grainTabs = root.querySelectorAll('.quality-stats__grain-tab');
        var tableBody = q('[data-control="tableBody"]');
        var tableWrapper = q('[data-control="tableWrapper"]');
        var loadingEl = q('[data-control="loadingIndicator"]');
        var errorEl = q('[data-control="errorMessage"]');
        var noResultsEl = q('[data-control="noResultsMessage"]');
        var regionErrorEl = q('[data-control="regionErrorMessage"]');
        var regionErrorTextEl = q('[data-control="regionErrorText"]');
        var regionErrorTemplate = regionErrorTextEl
            ? regionErrorTextEl.textContent
            : '';
        var noRegionsEl = q('[data-control="noRegionsConfigured"]');
        var exportBtn = q('[data-control="exportExcel"]');
        var exportDownloadLink = q('[data-control="exportDownload"]');
        var theadEl = q('[data-control="tableHead"]');
        var headerRow = q('[data-control="headerRow"]');
        var headerCellPrototype = q('[data-control="headerCellPrototype"]');
        var tableRowPrototype = q('[data-control="tableRowPrototype"]');
        var tableCellPrototype = q('[data-control="tableCellPrototype"]');
        var contentPanel = q('#qs-results-panel');
        var grainTabsWrap = q('[data-control="grainTabs"]');
        var grainToggle = q('[data-control="grainToggle"]');
        var grainToggleLabel = q('[data-control="grainToggleLabel"]');

        function clonePrototype(prototype) {
            return prototype ? prototype.cloneNode(true) : null;
        }

        function clearChildren(el) {
            if (el) el.replaceChildren();
        }

        function showPrototypeClone(el) {
            if (!el) return;
            el.classList.remove('quality-stats__prototype');
            el.removeAttribute('aria-hidden');
        }

        function setAriaHidden(el, hidden) {
            if (el) el.setAttribute('aria-hidden', hidden ? 'true' : 'false');
        }

        function showRegionError(failedNames) {
            if (!regionErrorEl) return;
            if (!failedNames.length) {
                setAriaHidden(regionErrorEl, true);
                return;
            }
            if (regionErrorTextEl) {
                regionErrorTextEl.textContent = regionErrorTemplate.replace(
                    '{region}',
                    failedNames.join(', ')
                );
            }
            setAriaHidden(regionErrorEl, false);
        }

        function setExportEnabled(enabled) {
            if (!exportBtn) return;
            exportBtn.disabled = !enabled;
            exportBtn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
        }

        function showLoading() {
            setAriaHidden(loadingEl, false);
            setAriaHidden(errorEl, true);
            setAriaHidden(noResultsEl, true);
            setAriaHidden(tableWrapper, true);
            setExportEnabled(false);
        }

        function showTable(rows) {
            setAriaHidden(loadingEl, true);
            setAriaHidden(tableWrapper, rows.length === 0 ? true : false);
            setAriaHidden(errorEl, true);
            setAriaHidden(noResultsEl, rows.length === 0 ? false : true);
            setExportEnabled(rows.length > 0);
        }

        function showError() {
            setAriaHidden(loadingEl, true);
            setAriaHidden(tableWrapper, true);
            setAriaHidden(noResultsEl, true);
            setAriaHidden(errorEl, false);
            setExportEnabled(false);
        }

        function showNoRegionsConfigured() {
            setAriaHidden(loadingEl, true);
            setAriaHidden(tableWrapper, true);
            setAriaHidden(noResultsEl, true);
            setAriaHidden(errorEl, true);
            setAriaHidden(regionErrorEl, true);
            setAriaHidden(noRegionsEl, false);
            setExportEnabled(false);
        }

        function focusSeasonItem(item) {
            if (!item) return;
            item.focus();
        }

        function getSeasonItemsArray() {
            return Array.prototype.slice.call(seasonItems || []);
        }

        function getActiveSeasonItem() {
            var items = getSeasonItemsArray();
            for (var i = 0; i < items.length; i++) {
                if (items[i].getAttribute('aria-selected') === 'true') {
                    return items[i];
                }
            }
            return items[0] || null;
        }

        function focusSeasonByOffset(offset) {
            var items = getSeasonItemsArray();
            if (!items.length) return;
            var active = document.activeElement;
            var idx = items.indexOf(active);
            if (idx === -1) idx = items.indexOf(getActiveSeasonItem());
            if (idx === -1) idx = 0;
            var next = (idx + offset + items.length) % items.length;
            focusSeasonItem(items[next]);
        }

        function focusSeasonByPosition(position) {
            var items = getSeasonItemsArray();
            if (!items.length) return;
            focusSeasonItem(
                position === 'last' ? items[items.length - 1] : items[0]
            );
        }

        function fetchInScopeSites(callback) {
            if (!REGION_NAMES.length) {
                callback();
                return;
            }
            Promise.all(
                REGION_NAMES.map(function(name) {
                    return fetch(REGIONS_API[name], {
                        headers: { Accept: 'application/json' },
                    })
                        .then(function(res) {
                            if (!res.ok) throw new Error('HTTP ' + res.status);
                            return res.json();
                        })
                        .then(function(data) {
                            return { name: name, sites: extractArray(data) };
                        })
                        .catch(function() {
                            return { name: name, sites: null };
                        });
                })
            ).then(function(regionResults) {
                var set = new Set();
                var failedNames = [];
                regionResults.forEach(function(result) {
                    if (result.sites === null) {
                        failedNames.push(result.name);
                        return;
                    }
                    result.sites.forEach(function(s) {
                        var name = getSiteName(s);
                        if (name) set.add(name);
                    });
                });
                inScopeSites = set;
                showRegionError(failedNames);
                callback();
            });
        }

        function fetchSeasons(callback) {
            fetch(SEASONS_API, { headers: { Accept: 'application/json' } })
                .then(function(response) {
                    if (!response.ok)
                        throw new Error('HTTP ' + response.status);
                    return response.json();
                })
                .then(function(data) {
                    var list = Array.isArray(data)
                        ? data
                        : Array.isArray(data && data.value)
                        ? data.value
                        : [];
                    var latest = list.slice(-3).reverse();
                    callback(null, latest);
                })
                .catch(function(err) {
                    callback(err);
                });
        }

        function buildSeasonMenu(seasons) {
            clearChildren(seasonMenu);
            var fragment = document.createDocumentFragment();
            seasons.forEach(function(s, idx) {
                var li = clonePrototype(seasonItemPrototype);
                if (!li) return;
                li.className =
                    'quality-stats__season-item' +
                    (idx === 0 ? ' -active' : '');
                li.removeAttribute('data-control');
                showPrototypeClone(li);
                li.setAttribute('role', 'option');
                li.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
                li.setAttribute('tabindex', '0');
                li.setAttribute('data-season', s.season);
                li.setAttribute('data-label', s.description);
                li.textContent = s.description;
                li.addEventListener('click', function() {
                    selectSeason(li);
                });
                li.addEventListener('keydown', function(e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        selectSeason(li);
                        seasonToggle.focus();
                    } else if (e.key === 'ArrowDown') {
                        e.preventDefault();
                        focusSeasonByOffset(1);
                    } else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        focusSeasonByOffset(-1);
                    } else if (e.key === 'Home') {
                        e.preventDefault();
                        focusSeasonByPosition('first');
                    } else if (e.key === 'End') {
                        e.preventDefault();
                        focusSeasonByPosition('last');
                    } else if (e.key === 'Escape') {
                        e.preventDefault();
                        closeSeasonMenu();
                        seasonToggle.focus();
                    }
                });
                fragment.appendChild(li);
            });
            seasonMenu.appendChild(fragment);

            seasonItems = root.querySelectorAll('.quality-stats__season-item');

            if (seasons.length > 0) {
                currentSeason = seasons[0].season;
                currentLabel = seasons[0].description;
                seasonValue.textContent = currentLabel;
            }
        }

        function buildApiUrl(grainCode, season) {
            return buildUrl(STATISTICS_API, {
                grainCode: grainCode,
                season: season,
            });
        }

        function getQualityValue(row, testType) {
            var qualities = row.qualities;
            if (!Array.isArray(qualities)) return '';
            for (var i = 0; i < qualities.length; i++) {
                if (qualities[i].testType === testType) {
                    var val = qualities[i].result;
                    return val != null ? val : '';
                }
            }
            return '';
        }

        function getCellValue(row, col) {
            if (col.isQuality) return getQualityValue(row, col.testType);
            var val = row[col.field];
            return val != null ? val : '';
        }

        function fetchData(grainCode, season) {
            if (!REGION_NAMES.length) {
                showNoRegionsConfigured();
                return;
            }
            var cacheKey = grainCode + '|' + season;

            if (dataCache[cacheKey]) {
                var cached = dataCache[cacheKey];
                currentData = cached;
                renderHeader(grainCode);
                renderRows(cached, grainCode);
                showTable(cached);
                return;
            }

            showLoading();

            fetch(buildApiUrl(grainCode, season), {
                headers: { Accept: 'application/json' },
            })
                .then(function(response) {
                    if (!response.ok)
                        throw new Error('HTTP ' + response.status);
                    return response.json();
                })
                .then(function(data) {
                    var rows = Array.isArray(data)
                        ? data
                        : Array.isArray(data && data.value)
                        ? data.value
                        : [];

                    if (inScopeSites) {
                        rows = rows.filter(function(row) {
                            return inScopeSites.has(row.siteDescription);
                        });
                    }

                    dataCache[cacheKey] = rows;
                    currentData = rows;
                    renderHeader(grainCode);
                    renderRows(rows, grainCode);
                    showTable(rows);
                })
                .catch(function() {
                    currentData = [];
                    showError();
                });
        }

        function prefetchOtherGrains(season) {
            GRAIN_TYPES.forEach(function(g) {
                var key = g.code + '|' + season;
                if (dataCache[key]) return;
                fetch(buildApiUrl(g.code, season), {
                    headers: { Accept: 'application/json' },
                })
                    .then(function(r) {
                        return r.ok ? r.json() : Promise.reject();
                    })
                    .then(function(data) {
                        var rows = Array.isArray(data)
                            ? data
                            : Array.isArray(data && data.value)
                            ? data.value
                            : [];
                        if (inScopeSites) {
                            rows = rows.filter(function(row) {
                                return inScopeSites.has(row.siteDescription);
                            });
                        }
                        dataCache[key] = rows;
                    })
                    .catch(function() {});
            });
        }

        function renderHeader(grainCode) {
            if (!theadEl || !headerRow || !headerCellPrototype) return;

            clearChildren(headerRow);
            var fragment = document.createDocumentFragment();
            getColumns(grainCode).forEach(function(col) {
                var th = clonePrototype(headerCellPrototype);
                if (!th) return;
                var labelEl = th.querySelector('[data-control="headerLabel"]');
                var breakEl = th.querySelector('[data-control="headerBreak"]');
                var unitEl = th.querySelector('[data-control="headerUnit"]');
                var labelParts = col.label.match(/^(.*?) ((?:%|kg).*)$/);
                th.scope = 'col';
                th.className = col.cellClass;
                th.removeAttribute('data-control');
                showPrototypeClone(th);
                if (labelParts) {
                    if (labelEl) labelEl.textContent = labelParts[1];
                    if (breakEl) breakEl.classList.add('-visible');
                    if (unitEl) unitEl.textContent = labelParts[2];
                } else if (labelEl) {
                    labelEl.textContent = col.label;
                    if (unitEl) unitEl.textContent = '';
                }
                fragment.appendChild(th);
            });
            headerRow.appendChild(fragment);
        }

        function formatNumber(val) {
            if (val === null || val === undefined || val === '') return '';
            var num = parseFloat(val);
            return isNaN(num) ? val : num.toFixed(2);
        }

        function renderRows(rows, grainCode) {
            clearChildren(tableBody);
            if (!rows.length) return;

            var cols = getColumns(grainCode);
            var fragment = document.createDocumentFragment();

            rows.forEach(function(row) {
                var tr = clonePrototype(tableRowPrototype);
                if (!tr) return;
                var rowCellPrototype =
                    tr.querySelector('[data-control="tableCellPrototype"]') ||
                    tableCellPrototype;
                clearChildren(tr);
                tr.removeAttribute('data-control');
                showPrototypeClone(tr);
                cols.forEach(function(col) {
                    var td = clonePrototype(rowCellPrototype);
                    if (!td) return;
                    var cellValue = td.querySelector(
                        '[data-control="cellValue"]'
                    );
                    td.className = col.cellClass;
                    td.removeAttribute('data-control');
                    td.setAttribute('data-label', col.label);
                    var raw = getCellValue(row, col);
                    var value = col.isQuality
                        ? formatNumber(raw)
                        : raw !== ''
                        ? raw
                        : '';
                    if (cellValue) {
                        cellValue.textContent = value;
                    } else {
                        td.textContent = value;
                    }
                    tr.appendChild(td);
                });
                fragment.appendChild(tr);
            });

            tableBody.appendChild(fragment);
        }

        function exportToExcel() {
            if (!currentData || !currentData.length) return;

            var cols = getColumns(currentGrain);
            var aoa = [
                cols.map(function(c) {
                    return c.label;
                }),
            ];

            currentData.forEach(function(row) {
                aoa.push(
                    cols.map(function(col) {
                        var val = getCellValue(row, col);
                        if (val == null) return '';
                        if (col.isQuality) {
                            var num = parseFloat(val);
                            return isNaN(num) ? '' : parseFloat(num.toFixed(3));
                        }
                        return String(val);
                    })
                );
            });

            var ws = XLSX.utils.aoa_to_sheet(aoa);
            ws['!cols'] = cols.map(function(col) {
                if (col.field === 'siteDescription') return { wch: 24 };
                if (col.field === 'grade') return { wch: 12 };
                return { wch: 18 };
            });
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, currentGrainLabel);

            var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            var blob = new Blob([wbout], {
                type:
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            var pad = function(n) {
                return String(n).padStart(2, '0');
            };
            var now = new Date();
            var date =
                now.getFullYear() +
                '-' +
                pad(now.getMonth() + 1) +
                '-' +
                pad(now.getDate()) +
                '-' +
                pad(now.getHours()) +
                '-' +
                pad(now.getMinutes());
            var filename = 'Bunge_QualityStatistics_' + date + '.xlsx';

            var url = window.URL.createObjectURL(blob);
            var a = exportDownloadLink;
            if (!a) return;
            a.href = url;
            a.download = filename;
            a.click();
            setTimeout(function() {
                window.URL.revokeObjectURL(url);
            }, 1000);
        }

        function openSeasonMenu(focusSelected) {
            closeGrainSelector();
            seasonMenu.classList.add('-visible');
            seasonDropdown.classList.add('-open');
            seasonToggle.setAttribute('aria-expanded', 'true');
            if (focusSelected) {
                setTimeout(function() {
                    focusSeasonItem(getActiveSeasonItem());
                }, 0);
            }
        }

        function closeSeasonMenu() {
            seasonMenu.classList.remove('-visible');
            seasonDropdown.classList.remove('-open');
            seasonToggle.setAttribute('aria-expanded', 'false');
        }

        function toggleSeasonMenu() {
            seasonMenu.classList.contains('-visible')
                ? closeSeasonMenu()
                : openSeasonMenu();
        }

        function selectSeason(item) {
            var season = item.getAttribute('data-season');
            if (season === currentSeason) {
                closeSeasonMenu();
                return;
            }

            currentSeason = season;
            currentLabel = item.getAttribute('data-label');
            seasonValue.textContent = currentLabel;
            dataCache = {};

            seasonItems.forEach(function(el) {
                var active = el === item;
                el.classList.toggle('-active', active);
                el.setAttribute('aria-selected', active ? 'true' : 'false');
            });

            closeSeasonMenu();
            fetchData(currentGrain, currentSeason);
            setTimeout(function() {
                prefetchOtherGrains(currentSeason);
            }, 0);
        }

        function selectGrainTab(tab) {
            var grain = tab.getAttribute('data-grain');
            if (grain === currentGrain) {
                return;
            }

            currentGrain = grain;
            currentGrainLabel = tab.getAttribute('data-label');
            updateGrainToggleLabel(currentGrainLabel || tab.textContent.trim());

            grainTabs.forEach(function(t) {
                var active = t === tab;
                t.classList.toggle('-active', active);
                t.setAttribute('aria-selected', active ? 'true' : 'false');
                t.setAttribute('tabindex', '0');
                if (active && contentPanel && t.id) {
                    contentPanel.setAttribute('aria-labelledby', t.id);
                }
            });

            fetchData(currentGrain, currentSeason);
        }

        function isMobileGrainSelector() {
            return window.matchMedia('(max-width: 991px)').matches;
        }

        function closeGrainSelector() {
            if (grainTabsWrap) grainTabsWrap.classList.remove('-open');
            if (grainToggle) grainToggle.setAttribute('aria-expanded', 'false');
        }

        function toggleGrainSelector() {
            if (!grainTabsWrap) return;
            closeSeasonMenu();
            var isOpen = grainTabsWrap.classList.toggle('-open');
            if (grainToggle) {
                grainToggle.setAttribute('aria-expanded', String(isOpen));
            }
        }

        function updateGrainToggleLabel(label) {
            if (grainToggleLabel) grainToggleLabel.textContent = label || '';
        }

        function focusGrainTabByOffset(currentTab, offset) {
            var tabs = Array.prototype.slice.call(grainTabs || []);
            if (!tabs.length) return;
            var idx = tabs.indexOf(currentTab);
            if (idx === -1) idx = 0;
            var next = (idx + offset + tabs.length) % tabs.length;
            tabs[next].focus();
            selectGrainTab(tabs[next]);
        }

        function setupGrainTabsAccessibility() {
            grainTabs.forEach(function(tab, idx) {
                if (!tab.id) tab.id = 'qs-grain-tab-' + idx;
                tab.setAttribute('tabindex', '0');
                tab.setAttribute('aria-controls', 'qs-results-panel');
                if (tab.classList.contains('-active') && contentPanel) {
                    contentPanel.setAttribute('aria-labelledby', tab.id);
                }
                if (tab.classList.contains('-active') && grainTabsWrap) {
                    updateGrainToggleLabel(
                        tab.getAttribute('data-label') || tab.textContent.trim()
                    );
                }

                tab.addEventListener('keydown', function(e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        selectGrainTab(tab);
                        if (!isMobileGrainSelector()) closeGrainSelector();
                    } else if (
                        e.key === 'ArrowRight' ||
                        e.key === 'ArrowDown'
                    ) {
                        e.preventDefault();
                        focusGrainTabByOffset(tab, 1);
                    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                        e.preventDefault();
                        focusGrainTabByOffset(tab, -1);
                    } else if (e.key === 'Home') {
                        e.preventDefault();
                        grainTabs[0].focus();
                        selectGrainTab(grainTabs[0]);
                    } else if (e.key === 'End') {
                        e.preventDefault();
                        grainTabs[grainTabs.length - 1].focus();
                        selectGrainTab(grainTabs[grainTabs.length - 1]);
                    } else if (e.key === 'Escape') {
                        closeGrainSelector();
                    }
                });
            });
        }

        seasonToggle.addEventListener('click', function(e) {
            e.stopPropagation();
            toggleSeasonMenu();
        });

        seasonToggle.addEventListener('keydown', function(e) {
            if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                openSeasonMenu(true);
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                openSeasonMenu(false);
                setTimeout(function() {
                    focusSeasonByPosition('last');
                }, 0);
            } else if (e.key === 'Escape') {
                closeSeasonMenu();
            }
        });

        seasonDropdown.addEventListener('focusout', function(e) {
            if (!seasonDropdown.contains(e.relatedTarget)) closeSeasonMenu();
        });

        document.addEventListener('click', function(e) {
            if (!seasonDropdown.contains(e.target)) closeSeasonMenu();
            if (!e.target.closest('.quality-stats__grain-tabs')) {
                closeGrainSelector();
            }
        });

        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                closeSeasonMenu();
                closeGrainSelector();
            }
        });

        grainTabs.forEach(function(tab) {
            tab.addEventListener('click', function(e) {
                if (tab.classList.contains('-active')) {
                    if (grainTabsWrap) grainTabsWrap.classList.toggle('-open');
                    return;
                }
                if (grainTabsWrap) grainTabsWrap.classList.remove('-open');
                selectGrainTab(tab);
            });
        });

        if (grainToggle) {
            grainToggle.addEventListener('click', function(e) {
                e.stopPropagation();
                toggleGrainSelector();
            });
            grainToggle.addEventListener('keydown', function(e) {
                if (e.key !== 'Enter' && e.key !== ' ') return;
                e.preventDefault();
                toggleGrainSelector();
            });
        }

        setupGrainTabsAccessibility();

        if (receivalsDate) receivalsDate.textContent = new Date().toDateString();

        if (exportBtn) exportBtn.addEventListener('click', exportToExcel);

        if (!REGION_NAMES.length) {
            showNoRegionsConfigured();
        } else {
            fetchInScopeSites(function() {
                fetchSeasons(function(err, seasons) {
                    if (err || !seasons.length) {
                        showError();
                        return;
                    }
                    buildSeasonMenu(seasons);
                    fetchData(currentGrain, currentSeason);
                    setTimeout(function() {
                        prefetchOtherGrains(currentSeason);
                    }, 0);
                });
            });
        }
    })();
}
